// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2Sn8f","addWidgetButton":"Header_addWidgetButton__rEOr9","dashboardTabs":"Header_dashboardTabs__2O_ww","active":"Header_active__3lAOK"};